import React, { useEffect, useState } from "react";
import axios from "axios";
import { Table, Button, Popconfirm, message, Form, Row, Col } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import "../index.css";
import { API_URL } from "../../config";
import CommonModal from "../common/commonModal/CommonModal";
import AntDesignTable from "../common/antTable/AntDesignTable";
import KioskForm from "./KioskForm";
import { useTranslation } from "react-i18next";

const KiosksContainer = () => {
  const [kiosks, setKiosks] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentKiosk, setCurrentKiosk] = useState([]);
  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    fetchKiosks();
  }, []);

  const fetchKiosks = async () => {
    try {
      const response = await axios.get(`${API_URL}/kiosk/?skip=0&limit=100`);
      setKiosks(response.data);
    } catch (error) {
      console.error("There was an error fetching the kiosk data!", error);
    }
  };

  const fetchKioskDetails = async (kiosk_id) => {
    try {
      const response = await axios.get(`${API_URL}/kiosk/${kiosk_id}`);
      setCurrentKiosk(response.data);
      form.setFieldsValue(response.data);
    } catch (error) {
      console.error("There was an error fetching the kiosk details!", error);
    }
  };

  const handleEdit = async (record) => {
    await fetchKioskDetails(record.kiosk_id);
    setIsModalVisible(true);
  };

  const handleDelete = async (kiosk_id) => {
    try {
      await axios.delete(`${API_URL}/kiosk/${kiosk_id}`);
      message.success(t("message.kioskDeletedSuccessfully"));
      fetchKiosks();
    } catch (error) {
      console.error("There was an error deleting the kiosk data!", error);
      message.error(t("message.failedKioskDelete"));
    }
  };

  const handleOk = async () => {
    try {
      await form.validateFields();
      const formData = form.getFieldsValue();

      if (formData.company_id) {
        const value = formData.company_id.trim();

        const regex = /^[A-Za-z0-9\s-]+$/;

        if (!regex.test(value)) {
          message.error(t("validation.invalidCompanyId"));
          return;
        }

        formData.company_id = value;
      }

      if (currentKiosk && currentKiosk.kiosk_id) {
        await axios.patch(`${API_URL}/kiosk/${currentKiosk.kiosk_id}`, formData);
        message.success(t("message.kioskUpdatedSuccessfully"));
      } else {
        await axios.post(`${API_URL}/kiosk/`, formData);
        message.success(t("message.kioskCreatedSuccessfully"));
      }

      setIsModalVisible(false);
      fetchKiosks();
    } catch (error) {
      console.error("Error occurred:", error);

      if (error.response?.data?.detail) {
        const detail = error.response.data.detail;
        const kioskMessage =
          typeof detail === "string"
            ? detail.includes("::")
              ? detail.split("::")[1]
              : detail
            : "An error occurred.";
        message.error(kioskMessage);
      } else {
        message.error(t("message.formSubmissionError"));
      }
    }
  };






  const handleCreate = () => {
    form.resetFields();
    setCurrentKiosk(null);
    setIsModalVisible(true);
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const columns = [
    {
      title: t("tableHeader.kioskId"),
      dataIndex: "kiosk_id",
      key: "kiosk_id",
    },
    {
      title: t("tableHeader.name"),
      dataIndex: "name",
      key: "name",
    },
    {
      title: t("tableHeader.openTime"),
      dataIndex: "open_time",
      key: "open_time",
    },
    {
      title: `${t("tableHeader.address")} 1`,
      dataIndex: "address_1",
      key: "address_1",
    },
    {
      title: t("tableHeader.country"),
      dataIndex: "country",
      key: "country",
    },
    {
      title: t("tableHeader.action"),
      key: "action",
      render: (text, record) => (
        <span>
          <Row gutter={[8, 8]}>
            <Col xs={12} sm={8} md={6}>
              <Button
                className="edit-button"
                icon={<EditOutlined />}
                onClick={() => handleEdit(record)}
              />
            </Col>
            <Col xs={12} sm={8} md={6}>
              <Popconfirm
                title={t("message.kioskDeleteConfirmation")}
                onConfirm={() => handleDelete(record.kiosk_id)}
                okText={t('common.yes')}
                cancelText={t('common.no')}
              >
                <Button
                  className="delete-button"
                  icon={<DeleteOutlined />}
                  style={{ marginLeft: 8 }}
                />
              </Popconfirm>
            </Col>
          </Row>
        </span>
      ),
    },
  ];

  return (
    <>
      <Button type="primary" icon={<PlusOutlined />} onClick={handleCreate}>
       
       {t("tableHeader.createNewKiosk")}
      </Button>

      <AntDesignTable columns={columns} tableData={kiosks} />
      <CommonModal
        title={currentKiosk ? t("tableHeader.editKiosk") : t("tableHeader.createKiosk")}
        visible={isModalVisible}
        onCancel={handleCancel}
        onConfirm={handleOk}
        confirmButtonText={currentKiosk ? t('common.update') : t('common.submit')}
      >
        <KioskForm form={form} initialValues={currentKiosk} />
      </CommonModal>
    </>
  );
};

export default KiosksContainer;
